import React from 'react';

import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseAdministrators from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAdministrators';

const pageSchema = PlanGetSchema.pages.administrators;
const pageId = pageSchema.pageId;

function PlanAdministrators({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];

    return (
        <BaseAdministrators
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanAdministrators;